import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M18.4265 4.18077L8.42654 11.1808C7.85782 11.5789 7.85782 12.4211 8.42654 12.8192L18.4265 19.8192C19.0893 20.2832 20 19.809 20 19V5C20 4.19098 19.0893 3.71682 18.4265 4.18077ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V5C6 4.44772 5.55228 4 5 4ZM18 6.92066V17.0793L10.7438 12L18 6.92066Z" />,
  'AudioPrev'
);
